import { el, mount, unmount, type RedomComponent } from "redom"
import CollapseList from './collapse-list.js'
import { SectionTitle } from './section-title.js'
import RecordTable from './record-table.js'
import { type RecordItem, RecordItemWithImage } from './record-item.js'
import type { RecordsSectionCtx, RecordsSectionData, RecordsWithUser } from "#/types.js"

export class RecordsSection implements RedomComponent {
    protected type: Constructor<RecordItem>
    sc_sec: HTMLElement
    protected records: RecordTable
    private collapseList: CollapseList
    sectionTitle: SectionTitle
    el: HTMLDivElement = el("div", { style: "display: none;" }, el(".row sc-section-divider"))
    constructor(tableType: Constructor<RecordItem> = RecordItemWithImage) {
        this.type = tableType
        mount(this,
            this.sc_sec = el(".sc-section", { style: "padding-bottom: 10px" },
                this.sectionTitle = new SectionTitle(),
                this.records = new RecordTable(tableType),
                this.collapseList = new CollapseList(tableType)
            )
        )
    }
    init(data: RecordsSectionData, context: RecordsSectionCtx = {}) {
        if (this.type == RecordItemWithImage) this.sc_sec.style.paddingBottom = !data.items.length ? "0" : "1.5rem"
        const numOfItem = data.numOfItem
        const items = data.items
        if (items.length >= numOfItem) this.sc_sec.style.paddingBottom = "10px"
        this.el.style.display = items.length > 0 || data.showMoreButton ? "block" : "none"
        this.records.init(items.slice(0, numOfItem), context)
        this.collapseList.init({ items: items.slice(numOfItem), collapseName: data.collapseName, numberBefore: data.numberBefore, showMoreButton: data.showMoreButton }, context)
    }
}

export class RecordsSectionWithBeforeList extends RecordsSection {
    private beforeList!: CollapseList
    updatePlaylist(data: RecordsSectionData, list: RecordsWithUser[], context: RecordsSectionCtx) {
        this.beforeList = new CollapseList(this.type)
        unmount(this.beforeList, this.beforeList.collapser)
        mount(this.beforeList.mainDiv, this.beforeList.border)
        this.sc_sec.insertBefore(this.beforeList.el, this.records.el)
        this.init(data, context)
        this.beforeList.init({ collapseName: data.collapseName, items: list.slice(0, data.numberBefore), noButton: true }, { targetUrl: context.targetUrl })
    }
}
